<template>
  <div class="board-container">
    <!-- 功能 -->
    <!-- <div class="header-menu">
      <el-select
        placeholder="年级"
        @change="queryClassByGrade"
        @clear="clearListener"
        clearable
      >
        <el-option v-for="item in grade" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>

    </div> -->
    <div>
      <el-table
        :header-cell-style="{
          background: '#fafafa'
        }"
        :data="list"
        :stripe="true"
        :highlight-current-row="true"
      >
        <!-- <el-table-column prop="operMethod" label="操作方法"></el-table-column> -->
        <el-table-column
          prop="operMethodName"
          label="方法名称"
        ></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">成功</span>
            <span v-else-if="scope.row.status === 1">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="操作人员"></el-table-column>
        <el-table-column prop="createTime" label="操作时间"></el-table-column>
      </el-table>
      <!-- 上一页，当前页，下一页 -->
      <div class="footer-button">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="optParameters.currentpage"
          :page-size="optParameters.pagesize"
          layout="prev, pager,next,sizes,jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";

export default {
  name: "ClassManager",
  data() {
    return {
      list: [],
      total: 0,
      optParameters: {
        pagesize: 10, //每页多少条
        currentpage: 1 //当前页码
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      const data = {
        page: this.optParameters.currentpage,
        limit: this.optParameters.pagesize
      }
      axios
        .post(`${apiBaseUrl}/operlog/list`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res);
          this.list = res.data.data.items;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },

    //分页
    handleSizeChange(pageSize) {
      this.optParameters.pagesize = pageSize;
      if (this.optParameters.page === 1) {
      }
      this.getList(this.optParameters);
    },
    //进入某一页
    handleCurrentChange(newPage) {
      this.optParameters.currentpage = newPage;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}

///* 兼容移动端 */
//@media screen and (max-width: 750px) {
//
//  /* 兼容移动端 */
//  #bb >>> .el-dialog {
//    width: 83%;
//  }
//}

@media screen and (max-width: 750px) {
  .board-container {
    /* overflow: auto; */
    width: 100%;
  }
}
  .footer-button {
    margin-top: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/manager/components/OperationLog.vue